/**
 *
 *
 *
 *
 */

export * from "./rum/rum";
export const {
  RUM: Rum,
  RUM: {
    sendCustomRequest,
    getPagecluster,
    sendImageBeacon,
    localStorageAvailable,
    navigationTimingAvailable,
    resourceTimingAvailable,
    storage,
    computeJsErrors,
  },
} = window.AS;
